import { Component, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject, merge } from 'rxjs';
import * as _ from 'lodash';
import { ItemService } from '../services/item.service';

@Component({
    styles: [`
        mat-dialog-content {
            width: 525px;
        }
    `],
    template: `
        <h2 mat-dialog-title>Change Source</h2>
        <mat-dialog-content  [formGroup]="form" fxLayout="column">
            <mat-form-field fxFlex>
                <input matInput placeholder="Search Term" formControlName="search">
                <mat-error *ngIf="form.controls.search.errors?.required">Search Term is required.</mat-error>    
            </mat-form-field>
            <mat-form-field fxFlex>
                <input matInput placeholder="API Token" formControlName="apiToken">
                <mat-error *ngIf="form.controls.search.errors?.required">API Token is required.</mat-error>    
            </mat-form-field>
            <create-source-preview-results [results]="results" [match]="match" style="padding-top: 20px;">
            </create-source-preview-results>
        </mat-dialog-content>
        <mat-dialog-actions>
        <button mat-raised-button [color]="results ? undefined : 'primary'" [disabled]="form.invalid" (click)="search()">Search</button>
        <button *ngIf="results" mat-raised-button color="primary" [mat-dialog-close]="form.value">Select</button>
        <button mat-button mat-dialog-close>Cancel</button>
        </mat-dialog-actions>
    `
})
export class DiffbotChangeSourceDialogComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    form: FormGroup;
    source: any;
    results: any;
    match: any;
    
    constructor(fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private snackbar: MatSnackBar, private itemService: ItemService) {
        this.source = data.source;
        this.form = fb.group({ 
            search: [this.source.search, Validators.required],
            apiToken: [this.source.apiToken, Validators.required]
        });

        merge(...['search', 'apiToken'].map(key => this.form.get(key).valueChanges))
        .pipe(takeUntil(this.cleanupTime))
        .subscribe(() => this.results = undefined);
    }

    search(): void {
        this.itemService.searchDiffbot(this.form.get('search').value, this.form.get('apiToken').value )
        .subscribe(
            items => this.results = { title: this.source.title, description: this.form.get('search').value, items },
            () => this.snackbar.open('Diffbot search failed', 'OK',  { duration: 5000 })
        );
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
